import omitBy from 'lodash/omitBy';
import isEmpty from 'lodash/isEmpty';

export function cleanObject(object) {
  return omitBy(object, isEmpty);
}
